import * as API from './api'
import * as Types from './Types'

export function tryCreateBookingSystemTime(token, bookableId, data) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_BOOKING_SYSTEM_TIME
    })

    API.createBookingSystemTime(token, bookableId, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_BOOKING_SYSTEM_TIME_SUCCESS,
          payload: { data: response.data.data, bookableId }
        })
      })
      .catch(error => {
        dispatch({
          type: Types.CREATE_BOOKING_SYSTEM_TIME_FAILED,
          payload: 500
        })
      })
  }
}

export function tryDeleteBookingSystemTime(token, bookableId, timeId) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_BOOKING_SYSTEM_TIME,
      payload: bookableId
    })

    API.deleteBookingSystemTime(token, bookableId, timeId)
      .then(() => {
        dispatch({
          type: Types.DELETE_BOOKING_SYSTEM_TIME_SUCCESS,
          payload: { bookableId, timeId }
        })
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_BOOKING_SYSTEM_TIME_FAILED,
          payload: { status: 500, bookableId }
        })
      })
  }
}

export function tryUpdateBookingSystemTime(token, bookableId, timeId, data) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_BOOKING_SYSTEM_TIME,
      payload: bookableId
    })

    API.updateBookingSystemTime(token, bookableId, timeId, data)
      .then(response => {
        dispatch({
          type: Types.UPDATE_BOOKING_SYSTEM_TIME_SUCCESS,
          payload: { data: response.data.data, bookableId }
        })
      })
      .catch(error => {
        dispatch({
          type: Types.UPDATE_BOOKING_SYSTEM_TIME_FAILED,
          payload: { status: 500, bookableId }
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/BookingSystemTimes.js